import { Date } from "isoly";
export var Filter;
(function (Filter) {
    function apply(filter, transactions) {
        return transactions.filter(t => {
            var _a, _b;
            let keep = true;
            if (filter.category && filter.category.length > 0)
                keep && (keep = filter.category.includes(t.category));
            if (keep && typeof filter.description == "string" && filter.description != "")
                keep && (keep = RegExp(filter.description, "i").test(t.description));
            if (keep && filter.description instanceof RegExp) {
                filter.description.lastIndex = 0;
                keep && (keep = filter.description.test(t.description));
            }
            if (keep && filter.amount && typeof filter.amount.gte == "number")
                keep && (keep = filter.amount.gte <= t.amount);
            if (keep && filter.amount && typeof filter.amount.lte == "number")
                keep && (keep = filter.amount.lte >= t.amount);
            if (keep && filter.date && Date.is((_a = filter.date) === null || _a === void 0 ? void 0 : _a.gte))
                keep && (keep = filter.date.gte <= t.date);
            if (keep && filter.date && Date.is((_b = filter.date) === null || _b === void 0 ? void 0 : _b.lte))
                keep && (keep = filter.date.lte >= t.date);
            return keep;
            /* return (!((filter.category?.length ?? 0) > 0) || filter.category.includes(t.category)) &&
          ((!(typeof filter.description == "string" && filter.description != "")) || RegExp(filter.description, "i").test(t.description)) &&
          ((!(filter.description instanceof RegExp)) || ((filter.description.lastIndex = 0) && filter.description.test(t.description))) &&
          ((!(typeof filter.amount?.$gte == "number")) && filter.amount.$gte <= t.amount) &&
          ((!(typeof filter.amount?.$lte == "number")) && filter.amount.$lte >= t.amount) &&
          ((!Date.is(filter.date?.$gte)) && filter.date.$gte <= t.date) &&
          ((!Date.is(filter.date?.$lte)) && filter.date.$lte >= t.date) */
        });
    }
    Filter.apply = apply;
    Filter.preFilters = [
        { filter: { description: /(willys|multimat|ica|livs|togkassen|grossen|lidl|prisma|orinthus|supermarket|shahwan tobak|torgkassen|annam)/i }, category: "groceries" },
        { filter: { description: /(max |forno|bageri|grill|sushi|pizza|landings|burger|taco)/i }, category: "resturant" },
        { filter: { description: /(apot)/i }, category: "health" },
        { filter: { description: /(plantagen|blom)/i }, category: "hobby" },
        { filter: { description: /(spotify|netflix|hbo)/i }, category: "subscriptions" },
        { filter: { description: /(preem|clas ?ohlson|avgift bankkort)/i }, category: "misc" },
        { filter: { description: /(destination gotland|sj internetbokning|bauhaus|jula)/i }, category: "transport" },
        { filter: { description: /(ikea)/i }, category: "household" },
        { filter: { description: /(ikea)/i, amount: { gte: 200, lte: 300 } }, category: "resturant" },
    ];
})(Filter || (Filter = {}));
